import { render, staticRenderFns } from "./PropertySearchResultHeader.vue?vue&type=template&id=707f23eb"
import script from "./PropertySearchResultHeader.vue?vue&type=script&lang=js"
export * from "./PropertySearchResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports